import { LinkFactoryOnClick } from 'common/link/link-on-click.js';
import { LinkFactoryReactRouter } from 'common/link/link-react-router.js';
import { Reference } from 'common/reference/reference.js';
import { ILink } from 'types/navigation.js';
import { LINKREF_WRAPPER_CLASSES } from 'utilities/consts.js';
import { IImageLinkCore } from 'utilities/image/image.js';

export type LinkRefProps = { link?: IImageLinkCore; center?: boolean };
/** This will be the new standard replacement for Tile-body-footer */
export const LinkRef = ({ link }: LinkRefProps) => {
  const { label, text, url } = link ?? {};
  const content = label ?? text;
  if (link && url && content) {
    return (
      <div className={LINKREF_WRAPPER_CLASSES} data-comp="link-ref">
        <LinkFactoryReactRouter
          href={url}
          target={link.target}
          className="u-flex-1 u-inlineBlock u-textCenter u-linkClean u-textBold u-text-sm"
          rel="noopener noreferrer"
        >
          {link.image ? (
            <Reference image={link.image} text={content} maxHeight={1.5} center={true} cleanLinkText={false} />
          ) : (
            link.label
          )}
        </LinkFactoryReactRouter>
      </div>
    );
  }
  return null;
};

type FakeLink = Partial<Omit<ILink, 'url'>> & {
  onClickCB?: ((e: React.MouseEvent<Element, MouseEvent>) => void) | undefined;
};

/** This will be the new standard replacement for Tile-body-footer */
export const LinkFakeRef = ({ onClickCB, label }: FakeLink) => {
  const onClick = (e: React.MouseEvent<Element, MouseEvent>) => {
    onClickCB?.(e);
    e.preventDefault();
  };

  if (label) {
    return (
      <div className={LINKREF_WRAPPER_CLASSES}>
        <LinkFactoryOnClick
          onClick={onClick}
          className="u-flex-1 u-inlineBlock u-textCenter u-linkClean u-textBold u-text-sm"
        >
          {label}
        </LinkFactoryOnClick>
      </div>
    );
  }
  return null;
};
